import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../../common/app';
import FormModal from '../../common/components/FormModal';
import Button from './Button';
import GroupBadge from './GroupBadge';
import Group from '../models/Group';
import extractText from '../utils/extractText';
import ItemList from '../utils/ItemList';
import Stream from '../utils/Stream';
import Form from './Form';
export default class EditUserModal extends FormModal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "username", void 0);
    _defineProperty(this, "email", void 0);
    _defineProperty(this, "isEmailConfirmed", void 0);
    _defineProperty(this, "setPassword", void 0);
    _defineProperty(this, "password", void 0);
    _defineProperty(this, "groups", {});
  }
  oninit(vnode) {
    super.oninit(vnode);
    const user = this.attrs.user;
    this.username = Stream(user.username() || '');
    this.email = Stream(user.email() || '');
    this.isEmailConfirmed = Stream(user.isEmailConfirmed() || false);
    this.setPassword = Stream(false);
    this.password = Stream(user.password() || '');
    const userGroups = user.groups() || [];
    app.store.all('groups').filter(group => ![Group.GUEST_ID, Group.MEMBER_ID].includes(group.id())).forEach(group => this.groups[group.id()] = Stream(userGroups.includes(group)));
  }
  className() {
    return 'EditUserModal Modal--small';
  }
  title() {
    return app.translator.trans('core.lib.edit_user.title');
  }
  content() {
    const fields = this.fields().toArray();
    return m("div", {
      className: "Modal-body"
    }, fields.length > 1 ? m(Form, null, this.fields().toArray()) : app.translator.trans('core.lib.edit_user.nothing_available'));
  }
  fields() {
    const items = new ItemList();
    if (this.attrs.user.canEditCredentials()) {
      items.add('username', m("div", {
        className: "Form-group"
      }, m("label", null, app.translator.trans('core.lib.edit_user.username_heading')), m("input", {
        className: "FormControl",
        placeholder: extractText(app.translator.trans('core.lib.edit_user.username_label')),
        bidi: this.username,
        disabled: this.nonAdminEditingAdmin()
      })), 40);
      if (app.session.user !== this.attrs.user) {
        items.add('email', m("div", {
          className: "Form-group"
        }, m("label", null, app.translator.trans('core.lib.edit_user.email_heading')), m("input", {
          className: "FormControl",
          placeholder: extractText(app.translator.trans('core.lib.edit_user.email_label')),
          bidi: this.email,
          disabled: this.nonAdminEditingAdmin()
        }), !this.isEmailConfirmed() && this.userIsAdmin(app.session.user) && m(Button, {
          className: "Button Button--block",
          loading: this.loading,
          onclick: this.activate.bind(this)
        }, app.translator.trans('core.lib.edit_user.activate_button'))), 30);
        items.add('password', m("div", {
          className: "Form-group"
        }, m("label", null, app.translator.trans('core.lib.edit_user.password_heading')), m("div", null, m("label", {
          className: "checkbox"
        }, m("input", {
          type: "checkbox",
          onchange: e => {
            const target = e.target;
            this.setPassword(target.checked);
            m.redraw.sync();
            if (target.checked) this.$('[name=password]').select();
            e.redraw = false;
          },
          disabled: this.nonAdminEditingAdmin()
        }), app.translator.trans('core.lib.edit_user.set_password_label'))), this.setPassword() && m("input", {
          className: "FormControl",
          type: "password",
          name: "password",
          placeholder: extractText(app.translator.trans('core.lib.edit_user.password_label')),
          bidi: this.password,
          disabled: this.nonAdminEditingAdmin()
        })), 20);
      }
    }
    if (this.attrs.user.canEditGroups()) {
      items.add('groups', m("div", {
        className: "Form-group EditUserModal-groups"
      }, m("label", null, app.translator.trans('core.lib.edit_user.groups_heading')), m("div", null, Object.keys(this.groups).map(id => app.store.getById('groups', id)).filter(Boolean).map(group =>
      // Necessary because filter(Boolean) doesn't narrow out falsy values.
      group && m("label", {
        className: "checkbox"
      }, m("input", {
        type: "checkbox",
        bidi: this.groups[group.id()],
        disabled: group.id() === Group.ADMINISTRATOR_ID && (this.attrs.user === app.session.user || !this.userIsAdmin(app.session.user))
      }), m(GroupBadge, {
        group: group,
        label: null
      }), " ", group.nameSingular())))), 10);
    }
    items.add('submit', m("div", {
      className: "Form-group Form-controls"
    }, m(Button, {
      className: "Button Button--primary",
      type: "submit",
      loading: this.loading
    }, app.translator.trans('core.lib.edit_user.submit_button'))), -10);
    return items;
  }
  activate() {
    this.loading = true;
    const data = {
      username: this.username(),
      isEmailConfirmed: true
    };
    this.attrs.user.save(data, {
      errorHandler: this.onerror.bind(this)
    }).then(() => {
      this.isEmailConfirmed(true);
      this.loading = false;
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
  data() {
    const data = {};
    const relationships = {};
    if (this.attrs.user.canEditCredentials() && !this.nonAdminEditingAdmin()) {
      data.username = this.username();
      if (app.session.user !== this.attrs.user) {
        data.email = this.email();
      }
      if (this.setPassword()) {
        data.password = this.password();
      }
    }
    if (this.attrs.user.canEditGroups()) {
      relationships.groups = Object.keys(this.groups).filter(id => this.groups[id]()).map(id => app.store.getById('groups', id)).filter(g => g instanceof Group);
    }
    data.relationships = relationships;
    return data;
  }
  onsubmit(e) {
    e.preventDefault();
    this.loading = true;
    this.attrs.user.save(this.data(), {
      errorHandler: this.onerror.bind(this)
    }).then(this.hide.bind(this)).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
  nonAdminEditingAdmin() {
    return this.userIsAdmin(this.attrs.user) && !this.userIsAdmin(app.session.user);
  }

  /**
   * @internal
   */
  userIsAdmin(user) {
    return !!((user == null ? void 0 : user.groups()) || []).some(g => (g == null ? void 0 : g.id()) === Group.ADMINISTRATOR_ID);
  }
}
flarum.reg.add('core', 'common/components/EditUserModal', EditUserModal);